/* unplugin-vue-components disabled */import script from "./RequestLoading.vue?vue&type=script&lang=ts&setup=true"
export * from "./RequestLoading.vue?vue&type=script&lang=ts&setup=true"

import "./RequestLoading.vue?vue&type=style&index=0&id=e6b4a012&lang=less&scoped=true"

import exportComponent from "G:\\code\\web\\cloud_live\\node_modules\\.pnpm\\vue-loader@17.0.1_vue@3.2.47_webpack@5.77.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e6b4a012"]])

export default __exports__